import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpEvent,
  HttpRequest,
  HttpHandler,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "src/app/auth/auth.service";

@Injectable()
export class SchoolYearInterceptor implements HttpInterceptor {
  constructor(private readonly authService: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.authService.schoolYear) {
      return this.getNewHeader(req, next, this.authService.schoolYear);
    }
    return next.handle(req);
  }

  private getNewHeader(
    req: HttpRequest<any>,
    next: HttpHandler,
    schoolYear: string
  ) {
    let headers = req.headers;
    headers = headers.set("SchoolYear", schoolYear);

    return next.handle(
      req.clone({
        headers: headers,
      })
    );
  }
}
